// tslint:disable:max-line-length
import * as React from 'react';
import { createIcon } from '../createIcon';

function Cross() {
  return React.createElement("svg", {
    width: "12",
    height: "12",
    viewBox: "0 0 12 12"
  }, React.createElement("g", {
    transform: "translate(-2 -2)"
  }, React.createElement("path", {
    "data-fill-rule": "fill",
    d: "M8 0a1 1 0 0 1 1 1v6h6a1 1 0 0 1 0 2H9v6a1 1 0 0 1-2 0V9H1a1 1 0 1 1 0-2h6V1a1 1 0 0 1 1-1z",
    transform: "rotate(45 8 8)"
  })));
}

export var CrossIcon = createIcon(Cross); // tslint:enable:max-line-length